module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "info1.954408a1.png";